<template>
	<div class="brick view_brick">
		<div class="view_inner">
			<div style="padding-bottom:15px;">
				<select class="tbl_select sm_int" v-model="selectedCategory">
					<option :value="null">All Category</option>
					<option v-for="(category, index) in categories" v-bind:value="category" v-bind:key="index">{{ category }}</option>
				</select>
			</div>
			<AdminSystemSettings :settings="filteredSettings" />
			<table class="view_tbl" v-if="selectedCategory == 'Company'">
				<colgroup>
					<col style="width:180px;" />
					<col style="width:120px;" />
					<col style="" />
				</colgroup>
				<tbody>
					<tr>
						<th>Email To</th>
						<td>
							<input type="text" v-model="email_to" class="tbl_int sm_int" style="width:230px;" @focus="$event.target.select()" />
						</td>
						<td>
							<a href="javascript:;" @click="emailTest()" type="button" class="search_bt mgr_15">Eamil Test</a>
						</td>
					</tr>
				</tbody>
			</table>

			<div class="view_bottom_bt">
				<a href="javascript:;" @click="submit()" type="button" class="search_bt">Save</a>
			</div>

			<!-- <br /> -->

			<table id="menu_list" class="list_tbl" border="0" style="width:400px">
				<thead>
					<tr>
						<th style="text-align:center;">GNB Name</th>
						<th style="text-align:center;">Name</th>
						<th style="text-align:center;">Active&nbsp;<input type="checkbox" @change="selectAll()" v-model="allSelected" /></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="menu in menus" v-bind:key="menu.path">
						<td class="al_left">{{ menu.gnb_name }}</td>
						<td class="al_left">{{ menu.name }}</td>
						<td class="al_center">
							<input type="checkbox" v-model="menu.active_yn" true-value="Y" false-value="N" />
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
import { inputSelectOnClick, emailRegExp } from '@/utils/etc.js';
import _ from 'lodash';
//import { apiSelectCompany, apiUpdateCompany } from '@/api/company.js';
import { apiSelectSystemSetting, apiUpdateSystemSetting, apiEmailTest } from '@/api/basicinfo/systemsetting.js';
//import Modal from '@/components/common/Modal';
import AdminSystemSettings from '@/views/basicinformation/AdminSystemSettings';

export default {
	data: function() {
		return {
			backUri: '/',
			company: {},

			//setting: {},
			settings: [],
			menus: [],

			email_to: null,

			modalName: '',
			showModal: false,

			allSelected: false,

			categories: [],
			selectedCategory: null,
		};
	},
	computed: {
		filteredSettings() {
			//console.log(this.selectedCategory);
			if (!this.selectedCategory) return this.settings;
			else return this.settings.filter(s => s.category == this.selectedCategory);
		},
	},
	components: {
		//ChangePassword,

		//Modal,
		AdminSystemSettings,
	},
	methods: {
		selectAll() {
			//console.log(this.allSelected);
			var vm = this;
			this.menus.forEach(function(menu) {
				menu.active_yn = vm.allSelected ? 'Y' : 'N';
			});
		},
		async selectSystemSetting() {
			const { data } = await apiSelectSystemSetting({ for_ss: true });

			this.menus = data.menuList;
			this.settings = data.settingList;
			this.categories = _.cloneDeep(_.uniq(this.settings.map(s => s.category)).sort());
			//console.log(this.categories);
		},
		async submit() {
			var response = await apiUpdateSystemSetting({ settings: this.settings, menus: this.menus });
			var data = response.data;

			if (data.result) {
				this.$toast.success('Saved successfully');
				//console.log(this.backUri);
				//this.$router.push(this.backUri);
				this.selectSystemSetting();
			} else {
				this.$toast.error(data.msg);
			}
		},
		async emailTest() {
			if (!this.email_to || !this.email_to.trim()) {
				this.$toast.error('Please enter a recipient email address.');
				return;
			}
			if (!emailRegExp(this.email_to.trim())) {
				this.$toast.error(`Invalid email address: ${this.email_to.trim()}`);
				return;
			}

			const { data } = await apiEmailTest({ email_to: this.email_to });
			console.log(data);
		},
	},
	created() {
		this.backUri = '/';

		//this.$store.sideIndex = 9;
		this.$store.commit('setSideIndex', 9);
		this.$store.commit('setSelectedMenu', 'nav_li_system_settings');
		this.$store.commit('setSubTitle', 'Basic Information -> System Settings');

		//this.selectCompany();
		this.selectSystemSetting();
	},
	mounted() {
		inputSelectOnClick();
	},
};
</script>

<style></style>
